import { render } from "./BasicEnquiryNumCard.vue?vue&type=template&id=1388b690"
import script from "./BasicEnquiryNumCard.vue?vue&type=script&lang=js"
export * from "./BasicEnquiryNumCard.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__